import script from "./ProductSpotPrice.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductSpotPrice.vue?vue&type=script&lang=ts&setup=true"

import "./ProductSpotPrice.vue?vue&type=style&index=0&id=3e91d1fb&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e91d1fb"]])

export default __exports__